import React from "react";
import dynamic from "next/dynamic";

import authService from "../../../common/service/authService";
import EnrollSectionBoxStyles from "./EnrollSectionBoxStyles";

const CourseProgress = dynamic(() => import("./CourseProgress"), {
  ssr: false,
});
const JoinCourse = dynamic(() => import("./JoinCourse"));
const EnrollForm = dynamic(() => import("./EnrollForm"));

const HandleRightSection: React.FC<NSCourses.IHeadSectionProps> = ({
  course,
}) => {
  return (
    <>
      {authService.isAuthenticated ? (
        !!course?.user_enrolled ? (
          <CourseProgress
            courseImage={course.course_image}
            name={course.name}
            progress={course?.user_progress || 0}
            slug={course.slug}
            isEligibalForCertificate={course?.is_eligible_for_certificate}
            certificateUrl={course?.certificate_download_url}
          />
        ) : (
          <JoinCourse enrollUrl={course.enroll_url} />
        )
      ) : (
        <EnrollSectionBoxStyles>
          <EnrollForm enrollUrl={course.enroll_url} />
        </EnrollSectionBoxStyles>
      )}
    </>
  );
};

export default HandleRightSection;
